// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","970":"component---src-pages-using-typescript-tsx"}[chunkId] || chunkId) + "-" + {"678":"6eac2c0d1fc85a6ced33","731":"f426ef555732d7edf6ca","843":"0f7e0e7b714f118a4a01","883":"ef85ee54b2bd6d642b3d","970":"504e046c31357b5ff4a9"}[chunkId] + ".js";
};